import { Box, Card, CardMedia } from "@mui/material";
import Habitacional from "../assets/habitacional.png";
import Industrial from "../assets/industrial.png";
import Entrada from '../assets/entrada.png'

const CardStack = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: 350,
        height: 400,
        margin: "auto",
      }}
    >
      <Card
        sx={{
          width: 200,
          height: 320,
          position: "absolute",
          top: 30,
          left: 0,
          borderRadius: 5,
          transform: "rotate(-10deg)",
          zIndex: 1,
          boxShadow: 3,
        }}
      >
        <CardMedia
          component="img"
          height="100%"
          image={Habitacional}
          alt="Imagen 1"
        />
      </Card>

      <Card
        sx={{
          width: 200,
          height: 320,
          position: "absolute",
          top: 0,
          left: 75,
          borderRadius: 5,
          zIndex: 3,
          boxShadow: 5,
        }}
      >
        <CardMedia
          component="img"
          height="100%"
          image={Entrada}
          alt="Imagen 2"
        />
      </Card>

      <Card
        sx={{
          width: 200,
          height: 320,
          position: "absolute",
          top: 30,
          left: 150,
          borderRadius: 5,
          transform: "rotate(10deg)",
          zIndex: 2,
          boxShadow: 3,
        }}
      >
        <CardMedia
          component="img"
          height="100%"
          image={Industrial}
          alt="Imagen 3"
        />
      </Card>
    </Box>
  );
};

export default CardStack;
